import React from 'react'
import { Card, Col, Row, Container, Image, Button } from 'react-bootstrap';

export default function ClientPage() {
  return (
   <>
    <section className='banner_strip'>
    <h1>Clients</h1>
    </section>
     <section className='section-4 section'>
        <Row>
          <Col lg={12}>
            <div className='clent-logo-box section-45'>
              <h5 className='sub-heading'>Clients</h5>
              <h1 className='title-heading'>
                Amazing Clients <br />Amazing Requirnments
              </h1>
              <div className='clent-logo-img-box'>
                <Row>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                      <img src={require('../assets/images/clients/1.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/2.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/3.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/4.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/5.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/6.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/7.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/8.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/9.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/10.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/11.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/12.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/13.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/14.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/15.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/16.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/17.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/18.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/19.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/20.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/21.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/22.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/23.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/24.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/25.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/26.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/27.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/28.png')} alt="c-1" />
                    </Card>
                  </Col>
                </Row>

              </div>
            </div>
          </Col>
          <Col lg={12}>
            <div className='clent-logo-box section-45'>
              <h5 className='sub-heading'>Affiliations</h5>
              <h1 className='title-heading'>
                National and <br />International Affiliations
              </h1>
              <div className='clent-logo-img-box clent-logo-img-box-right'>
                <Row >
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/affiliations/1.png')} alt="c-1" />
                    </Card>
                  </Col>

                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/affiliations/3.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/affiliations/4.png')} alt="c-1" />
                    </Card>
                  </Col>

                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/affiliations/6.png')} alt="c-1" />
                    </Card>
                  </Col>

                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/affiliations/2.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/affiliations/5.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/affiliations/7.png')} alt="c-1" />
                    </Card>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </section>
   </>
  )
}
